<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
    <div class="min-h-screen bg-white">
        <NavBar />
        <!-- 主视觉区域 -->
        <div class="pt-20 relative">
            <swiper :options="swiperOptions" class="hero-swiper">
                <swiper-slide v-for="(slide, index) in heroSlides" :key="index">
                    <div class="relative h-64 md:h-[400px] lg:h-[600px] w-full overflow-hidden">
                        <img :src="slide.image" :alt="slide.title" class="absolute inset-0 w-full h-full object-cover">
                        <!-- <div class="absolute inset-0 bg-gradient-to-r from-gray-900 to-transparent opacity-70"></div> -->
                        <div class="absolute inset-0 flex items-center">
                            <div class="container mx-auto px-6">
                                <div class="max-w-lg text-white">
                                    <h1 class="text-4xl md:text-5xl font-bold mb-4">{{ slide.title }}</h1>
                                    <p class="text-lg mb-8">{{ slide.description }}</p>
                                    <router-link to="/category-list">
                                        <button
                                            class="bg-[#76B900] hover:bg-[#5a8f00] text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300 !rounded-button whitespace-nowrap cursor-pointer">
                                            {{ slide.buttonText }}
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- 作品商城区块 -->
        <ShowcaseSection :showcases="showcases" />
        <!-- 产品分类区块 -->
        <CategorySection />
        <!-- 设计流程 -->
        <section class="py-16">
            <div class="container mx-auto px-6">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-gray-800 mb-2">定制流程</h2>
                    <p class="text-gray-600">简单四步，轻松获得专属于您的个性化产品</p>
                </div>
                <div class="relative">
                    <!-- 连接线 -->
                    <div class="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2 z-0">
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
                        <div v-for="(step, index) in designSteps" :key="index" class="text-center">
                            <div
                                class="bg-white rounded-full h-20 w-20 flex items-center justify-center mx-auto mb-4 border-4 border-[#76B900] shadow-md">
                                <i :class="step.icon + ' text-[#76B900] text-3xl'"></i>
                            </div>
                            <h3 class="text-xl font-semibold text-gray-800 mb-2">{{ step.title }}</h3>
                            <p class="text-gray-600">{{ step.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 特色功能 -->
        <section class="py-12 bg-gray-50">
            <div class="container mx-auto px-4">
                <div class="text-center mb-8">
                    <h2 class="text-2xl md:text-3xl font-bold text-gray-800 mb-2">特色功能</h2>
                    <p class="text-gray-600 text-base md:text-lg">我们提供强大的工具，帮助您实现创意</p>
                </div>
                <div class="flex flex-col gap-8 md:grid md:grid-cols-2 md:gap-12">
                    <div class="flex flex-col items-center md:flex-row md:items-start gap-4 md:gap-6">
                        <div class="flex-shrink-0">
                            <div class="bg-[#76B900] bg-opacity-10 rounded-full h-12 w-12 md:h-16 md:w-16 flex items-center justify-center">
                                <i class="fas fa-magic text-[#76B900] text-xl md:text-2xl"></i>
                            </div>
                        </div>
                        <div class="text-center md:text-left">
                            <h3 class="text-lg md:text-xl font-semibold text-gray-800 mb-1">AI 图案生成</h3>
                            <p class="text-gray-600 text-sm md:text-base">只需输入关键词描述，AI 将为您生成独特的图案设计，无需设计经验。</p>
                        </div>
                    </div>
                    <div class="flex flex-col items-center md:flex-row md:items-start gap-4 md:gap-6">
                        <div class="flex-shrink-0">
                            <div class="bg-[#76B900] bg-opacity-10 rounded-full h-12 w-12 md:h-16 md:w-16 flex items-center justify-center">
                                <i class="fas fa-edit text-[#76B900] text-xl md:text-2xl"></i>
                            </div>
                        </div>
                        <div class="text-center md:text-left">
                            <h3 class="text-lg md:text-xl font-semibold text-gray-800 mb-1">在线设计工具</h3>
                            <p class="text-gray-600 text-sm md:text-base">拖拽、旋转、缩放，实时预览效果，让您的创意得到完美呈现。</p>
                        </div>
                    </div>
                    <div class="flex flex-col items-center md:flex-row md:items-start gap-4 md:gap-6">
                        <div class="flex-shrink-0">
                            <div class="bg-[#76B900] bg-opacity-10 rounded-full h-12 w-12 md:h-16 md:w-16 flex items-center justify-center">
                                <i class="fas fa-tshirt text-[#76B900] text-xl md:text-2xl"></i>
                            </div>
                        </div>
                        <div class="text-center md:text-left">
                            <h3 class="text-lg md:text-xl font-semibold text-gray-800 mb-1">多品类支持</h3>
                            <p class="text-gray-600 text-sm md:text-base">T恤、保温杯、帆布袋等多种产品可选，满足您的不同需求。</p>
                        </div>
                    </div>
                    <div class="flex flex-col items-center md:flex-row md:items-start gap-4 md:gap-6">
                        <div class="flex-shrink-0">
                            <div class="bg-[#76B900] bg-opacity-10 rounded-full h-12 w-12 md:h-16 md:w-16 flex items-center justify-center">
                                <i class="fas fa-truck text-[#76B900] text-xl md:text-2xl"></i>
                            </div>
                        </div>
                        <div class="text-center md:text-left">
                            <h3 class="text-lg md:text-xl font-semibold text-gray-800 mb-1">快速生产交付</h3>
                            <p class="text-gray-600 text-sm md:text-base">专业生产线确保高质量成品，快速配送至您手中。</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 数据统计 -->
        <section class="py-16 bg-gray-900 text-white">
            <div class="container mx-auto px-6">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
                    <div>
                        <div class="text-4xl font-bold mb-2 text-[#76B900]">10,000+</div>
                        <p class="text-gray-300">满意客户</p>
                    </div>
                    <div>
                        <div class="text-4xl font-bold mb-2 text-[#76B900]">50,000+</div>
                        <p class="text-gray-300">定制产品</p>
                    </div>
                    <div>
                        <div class="text-4xl font-bold mb-2 text-[#76B900]">100+</div>
                        <p class="text-gray-300">AI 模板</p>
                    </div>
                    <div>
                        <div class="text-4xl font-bold mb-2 text-[#76B900]">98%</div>
                        <p class="text-gray-300">好评率</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- 用户评价 -->
        <section class="py-16">
            <div class="container mx-auto px-6">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-gray-800 mb-2">用户评价</h2>
                    <p class="text-gray-600">听听我们的客户怎么说</p>
                </div>
                <swiper :options="testimonialOptions" class="testimonial-swiper">
                    <swiper-slide v-for="(testimonial, index) in testimonials" :key="index">
                        <div class="bg-white rounded-xl shadow-md p-8 mx-4">
                            <div class="flex items-center mb-4">
                                <div class="text-[#76B900] text-2xl mr-2">
                                    <i class="fas fa-quote-left"></i>
                                </div>
                                <div class="text-yellow-400">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </div>
                            </div>
                            <p class="text-gray-600 mb-6">{{ testimonial.content }}</p>
                            <div class="flex items-center">
                                <img :src="testimonial.avatar" :alt="testimonial.name"
                                    class="w-12 h-12 rounded-full mr-4 object-cover">
                                <div>
                                    <h4 class="font-semibold text-gray-800">{{ testimonial.name }}</h4>
                                    <p class="text-gray-500 text-sm">{{ testimonial.title }}</p>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </section>
        <!-- 常见问题区块 -->
        <FAQSection :faqs="faqs" />
        <FooterBar />
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import NavBar from '@/components/common/NavBar.vue';
import FooterBar from '@/components/common/FooterBar.vue';
import ShowcaseSection from '@/components/home/ShowcaseSection.vue';
import CategorySection from '@/components/home/CategorySection.vue';
import FAQSection from '@/components/home/FAQSection.vue';
import { getGoodsList } from '@/api/product';

export default {
    name: 'HomePage',
    components: {
        Swiper,
        SwiperSlide,
        NavBar,
        FooterBar,
        ShowcaseSection,
        CategorySection,
        FAQSection
    },
    directives: {
        swiper: directive
    },
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                loop: true
            },
            testimonialOptions: {
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            },
            heroSlides: [
                {
                    title: "AI驱动的个性化定制",
                    description: "通过AI技术，将您的创意转化为独特的定制产品。",
                    buttonText: "开始定制",
                    image: require('@/assets/img/banner/banner1.jpg')
                },
                {
                    title: "品类定制满足多样需求",
                    description: "T恤、保温杯、帆布袋等多种产品，一站式解决您的定制需求。",
                    buttonText: "浏览产品",
                    image: require('@/assets/img/banner/banner2.jpg')
                },
                {
                    title: "在线设计轻松实现创意",
                    description: "简单的在线设计工具，让您无需专业技能也能创造精美作品。",
                    buttonText: "了解更多",
                    image: require('@/assets/img/banner/banner3.jpg')
                }
            ],
            showcases: [],
            designSteps: [
                {
                    title: "选择产品",
                    description: "从多种产品中选择您想要定制的类型",
                    icon: "fas fa-shopping-cart"
                },
                {
                    title: "上传/生成图案",
                    description: "上传您的图片或使用AI生成独特图案",
                    icon: "fas fa-cloud-upload-alt"
                },
                {
                    title: "在线设计",
                    description: "使用在线工具调整位置、大小和效果",
                    icon: "fas fa-palette"
                },
                {
                    title: "下单完成",
                    description: "确认设计，下单支付，等待商品送达",
                    icon: "fas fa-check-circle"
                }
            ],
            testimonials: [
                {
                    name: "张小明",
                    title: "设计师",
                    content: "AI 生成的图案超出了我的预期，质量非常高，印在 T 恤上效果惊艳。整个过程简单快捷，从设计到收到成品只用了 5 天时间。",
                    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20young%20asian%20male%20with%20glasses%2C%20neutral%20expression%2C%20clean%20background%2C%20studio%20lighting%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar1&orientation=squarish"
                },
                {
                    name: "李婷",
                    title: "市场经理",
                    content: "为团队定制了 20 个带公司标志的保温杯，质量和印刷效果都很好。客服非常耐心，帮我们调整了设计细节，团队都很满意。",
                    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20young%20asian%20female%20with%20business%20attire%2C%20neutral%20expression%2C%20clean%20background%2C%20studio%20lighting%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar2&orientation=squarish"
                },
                {
                    name: "王强",
                    title: "摄影爱好者",
                    content: "将我拍摄的风景照片印在了帆布袋上，效果非常棒，色彩还原度高。朋友们看到都很喜欢，已经推荐给了身边的朋友。",
                    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20middle-aged%20asian%20male%20with%20casual%20attire%2C%20neutral%20expression%2C%20clean%20background%2C%20studio%20lighting%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar3&orientation=squarish"
                },
                {
                    name: "赵雪",
                    title: "教师",
                    content: "为班级活动定制了纪念T恤，孩子们都非常喜欢。在线设计工具很容易上手，即使没有设计经验也能做出满意的效果。",
                    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20middle-aged%20asian%20female%20with%20professional%20attire%2C%20friendly%20smile%2C%20clean%20background%2C%20studio%20lighting%2C%20high%20quality%20portrait&width=100&height=100&seq=avatar4&orientation=squarish"
                }
            ],
            faqs: [
                {
                    question: "定制产品的交货时间是多久？",
                    answer: "一般情况下，从确认订单到发货需要3-5个工作日。特殊定制或批量订单可能需要更长时间，具体以订单确认时的信息为准。",
                    isOpen: true
                },
                {
                    question: "我可以使用自己的图片进行定制吗？",
                    answer: "当然可以。您可以上传自己的图片或设计，我们的系统会自动检查图片质量并提供优化建议，确保最终效果达到最佳。",
                    isOpen: false
                },
                {
                    question: "如何确保我上传的图片不会侵犯版权？",
                    answer: "请确保您上传的图片拥有合法使用权。我们的系统会进行基础的版权检查，但最终责任由用户承担。如有疑问，建议使用我们的AI生成功能创建原创图案。",
                    isOpen: false
                },
                {
                    question: "定制产品的质量如何保证？",
                    answer: "我们使用高品质的原材料和先进的印刷工艺，每件产品出厂前都会经过严格的质检。如收到的产品有质量问题，我们提供15天内的退换货服务。",
                    isOpen: false
                },
                // {
                //     question: "支持批量定制吗？有什么优惠？",
                //     answer: "我们支持企业批量定制，数量越多优惠越大。50件以上可享受9折优惠，100件以上可享受8.5折优惠，500件以上可享受8折优惠。企业客户还可联系客服获取更多专属方案。",
                //     isOpen: false
                // }
            ]
        };
    },
    mounted() {
        this.fetchShowcases();
    },
    methods: {
        async fetchShowcases() {
            try {
                const res = await getGoodsList({ order: 'CompositeOrder', page: 1, page_size: 10 });
                const data = res || {};
                this.showcases = (data.items || []).map(item => ({
                    id: item.id,
                    title: item.guide_title,
                    image: Array.isArray(item.main_image) ? item.main_image[0] : '',
                    price: item.fixed_price,
                    category: item.category_name,
                    sold: item.sale_number,
                    likes: item.collections_number,
                }));
            } catch (e) {
                this.showcases = [];
            }
        },
    }
};
</script>

<style scoped>
.hero-swiper .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.8);
    opacity: 0.5;
}

.hero-swiper .swiper-pagination-bullet-active {
    opacity: 1;
    background: #76B900;
}

.testimonial-swiper .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: #d1d5db;
    opacity: 0.5;
}

.testimonial-swiper .swiper-pagination-bullet-active {
    opacity: 1;
    background: #76B900;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>